<main class="main">
  <div class="main__outlet">
    <cp-notification></cp-notification>
    <router-outlet></router-outlet>
  </div>
  <cp-navigation></cp-navigation>
</main>
